import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import api from "../../../Environment";
import Slider from "../../SliderView/MainSlider";
import ContentCard from "../../Content/ContentCard";
import ContentLoader from "../../Static/contentLoader";
import { t } from "react-multi-lang";
import "./SubCategory.css";

const ROW_SIZE = 5;

/**
 * Subcategory landing — Home category rows open here, and videos, episodes and
 * seasons are browsed from inside the subcategory.
 */
class SubCategory extends Component {
  state = {
    loading: true,
    items: [],
    skip: 0,
    title: "",
    description: "",
    hasMore: true,
    loadingMore: false,
  };

  componentDidMount() {
    this.loadContent(0, true);
  }

  componentDidUpdate(prevProps) {
    const prevId = prevProps.match && prevProps.match.params.id;
    const nextId = this.props.match && this.props.match.params.id;
    if (prevId !== nextId) {
      if (this.skipParamReload) {
        this.skipParamReload = false;
        return;
      }
      this.setState({ loading: true, items: [], skip: 0, hasMore: true }, () =>
        this.loadContent(0, true)
      );
    }
  }

  subCategoryId() {
    return this.props.match && this.props.match.params
      ? this.props.match.params.id
      : null;
  }

  replaceNumericUrlWithSlug(slug) {
    const param = this.subCategoryId();
    const next = slug && String(slug).trim();
    if (
      !next ||
      !param ||
      !/^\d+$/.test(String(param)) ||
      !this.props.history ||
      typeof this.props.history.replace !== "function"
    ) {
      return;
    }
    this.skipParamReload = true;
    this.props.history.replace("/sub-category/" + next);
  }

  loadContent = (skip, replace) => {
    const subCategoryId = this.subCategoryId();
    if (!subCategoryId) return;

    api
      .postMethod("sub_category_videos", {
        sub_category_id: subCategoryId,
        skip: skip,
      })
      .then((response) => {
        const body = response.data || {};
        if (!body.success) {
          this.setState({ loading: false, loadingMore: false, hasMore: false });
          return;
        }
        const batch = Array.isArray(body.data) ? body.data : [];
        const details = body.sub_category || {};
        this.setState(
          (prev) => ({
            loading: false,
            loadingMore: false,
            items: replace ? batch : [...prev.items, ...batch],
            skip: (replace ? 0 : prev.skip) + batch.length,
            hasMore: batch.length > 0,
            title: details.name || prev.title,
            description: details.description || prev.description,
          }),
          () => {
            if (replace && details.slug) {
              this.replaceNumericUrlWithSlug(details.slug);
            }
          }
        );
      })
      .catch(() => {
        this.setState({ loading: false, loadingMore: false, hasMore: false });
      });
  };

  loadMore = (event) => {
    event.preventDefault();
    this.setState({ loadingMore: true });
    this.loadContent(this.state.skip, false);
  };

  itemKey(item, index) {
    return (
      item.content_item_id ||
      item.admin_video_id ||
      item.channel_id ||
      item.unique_id ||
      index
    );
  }

  chunk(items) {
    const rows = [];
    for (let i = 0; i < items.length; i += ROW_SIZE) {
      rows.push(items.slice(i, i + ROW_SIZE));
    }
    return rows;
  }

  render() {
    if (!this.subCategoryId()) {
      return <Redirect to="/home" />;
    }

    const { loading, items, title, description, hasMore, loadingMore } = this.state;

    if (loading) {
      return <ContentLoader />;
    }

    return (
      <div className="main p-40">
        <header className="subcategory-page-header">
          <h1 className="subcategory-page-header__title">{title}</h1>
          {description ? (
            <p className="subcategory-page-header__description">{description}</p>
          ) : null}
        </header>

        <div className="main-slidersec">
          {items.length === 0 ? (
            <div className="top-bottom-spacing text-center">
              <p className="grey-text">{t("no_results_found")}</p>
              <Link to="/home" className="btn btn-danger mt-3">
                Home
              </Link>
            </div>
          ) : (
            this.chunk(items).map((row, rowIndex) => (
              <Slider key={rowIndex}>
                {row.map((item, index) => (
                  <ContentCard
                    movie={item}
                    key={this.itemKey(item, rowIndex * ROW_SIZE + index)}
                  />
                ))}
              </Slider>
            ))
          )}
        </div>

        {items.length > 0 && hasMore ? (
          <div className="text-center">
            <button
              className="btn btn-lg"
              type="button"
              onClick={this.loadMore}
              disabled={loadingMore}
            >
              {loadingMore ? t("loading") : t("load_more")}
            </button>
          </div>
        ) : null}

        <div className="height-100" />
      </div>
    );
  }
}

export default SubCategory;
